import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useStoreItem, StoreItem } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<StoreItem>
    useData={useStoreItem}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
